module.exports = __webpack_public_path__ + "img/highlight.d2f152b7.svg";